module.exports = __webpack_public_path__ + "static/img/img(21).08464a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(21).png
// module id = O/iM
// module chunks = 1